import React from 'react';
import {commitLocalUpdate} from 'react-relay'
import environment from 'environment'
import Dashboard from 'components/Dashboard'
const fileUrl = (slug) => {  
  return FILE_SERVER + `/file/${slug}`
}

const withBaseComponent = (Component) => {
  return class extends React.Component {
    constructor(props) {      
      super(props)
      
      if (props.route.allowAll) {
        return
      }
      const hasUser = this.hasUser()
      if (props.route.notLoggedIn && hasUser) {
        props.router.replace("/home")
      }

      
      if (props.route.notLoggedIn) {        
        document.getElementById('indicatorArea').style.display = "none"
      }
      
      if (props.route.loginRequired && !hasUser) {        
        props.router.replace("/login")
      }      
      
    }

    hasUser() {      
      return localStorage.getItem("userToken")
    }
    localCommit(f) {
      commitLocalUpdate(environment, (proxy) => {
        f(proxy)        
      })        
    }

    render() {                  
      const comp = (<Component
                    localCommit={this.localCommit}
                    __environmentCtx={environment}
                    fileUrl={fileUrl}
                    {...this.props}/>
                   )
      
      return (
        (this.hasUser() && this.props.route.loginRequired)
          ?
          (<Dashboard
           localCommit={this.localCommit}
           __environmentCtx={environment}
           fileUrl={fileUrl}
           {...this.props}>
           {comp}
           </Dashboard>)
          :
        comp
      )
    }
  }
}

export default withBaseComponent
